import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global auth guard: if any request comes back 401 (session missing/expired/invalid),
// send the user cleanly back to sign-in instead of surfacing a confusing inline error
// (e.g. "Not authenticated" when trying to assign a task). Auth probe endpoints are
// skipped so the login/callback flow can handle their own 401s.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthProbe = url.includes("/auth/me") || url.includes("/auth/session") || url.includes("/auth/logout");
    if (status === 401 && !isAuthProbe && window.location.pathname !== "/login") {
      try { window.sessionStorage.setItem("twp_session_expired", "1"); } catch (e) { if (process.env.NODE_ENV === "development") console.debug("Session-expired flag write skipped:", e); }
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

// FastAPI returns `detail` as a STRING for HTTPException, but as an ARRAY of
// objects for 422 validation errors (and some proxies return no detail at all).
// Passing that array straight to toast.error() renders an object as a React
// child, which throws and trips the root ErrorBoundary -- the user sees
// "Something went wrong. Please reload the page." instead of the real reason.
// Always funnel API errors through this.
export function apiErr(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d)) {
    const msg = d
      .map((x) => (typeof x === "string" ? x : x?.msg))
      .filter(Boolean)
      .join(", ");
    if (msg) return msg;
  }
  if (d && typeof d === "object" && typeof d.msg === "string") return d.msg;
  if (typeof e?.response?.data?.error === "string") return e.response.data.error;
  if (e?.response?.status) return `${fallback} (${e.response.status})`;
  return fallback;
}

export default api;
